module.exports = __webpack_public_path__ + "img/canadian_tire.029508ce.jpg";